import { partition } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { sortBy } from '@paragon/utilities';

import { RootState } from '../store';

const getDocumentState = (state: RootState) => state.documents;
const getDocumentData = (state: RootState) => getDocumentState(state).pdfData;

export const getDocuments = createSelector(getDocumentData, (documents) => Object.values(documents));

export const getSortedDocuments = createSelector(getDocuments, (documents) =>
  sortBy(documents, (document) => document.index),
);

export const getSelectedDocument = createSelector(
  [getDocumentState],
  (documentState) => documentState.pdfData[documentState.activeDocumentId as number],
);

export const getSelectedPage = createSelector(
  [getDocumentState, getSelectedDocument],
  (documentState, selectedDocument) => {
    // This selector is sometimes used before a document has been selected
    if (selectedDocument === undefined) {
      return undefined; // TODO: fix and remove this check
    }

    return selectedDocument.pdfPages.find((page) => page.pageNumber === documentState.activePageNumber);
  },
);

export const getSelectedPageImageInfo = createSelector([getSelectedPage], (selectedPage) => {
  if (selectedPage == null) return null;
  return {
    dpi: selectedPage.pageImageDpi,
    pageImageWidth: selectedPage.pageImageWidth,
    pageImageHeight: selectedPage.pageImageHeight,
  };
});

export const getDocumentsAsSortedArray = createSelector([getDocuments], (documents) =>
  sortBy(documents, (document) => document.index),
);

/**
 * @return A tuple containing a list of components and a list of meta pdfs.
 */
export const getMetaPdfsAndComponentsAsSortedArrays = createSelector([getDocumentsAsSortedArray], (documents) =>
  partition(documents, (d) => d.componentDesignId == null),
);

export const getTotalNumberOfPdfs = createSelector([getDocuments], (documents) => documents.length);

export const getTotalNumberOfPagesInCurrentPdf = createSelector([getSelectedDocument], (document) => {
  if (document == null) return 0;
  return Object.values(document.pdfPages).length;
});
